<template>
  <d2-container>
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style="margin-top: 20px"
      :data="keywordList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="智能体标识">
        <template slot-scope="scope">
          <span>{{ scope.row.agentSign }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="类型">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type == 0" type="success">自有</el-tag>
          <el-tag v-else type="warning">扣子</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="420">
        <template slot-scope="scope">
          <el-button
            icon="el-icon-edit"
            size="small"
            type="primary"
            @click="editCard(scope.row.id)"
            style="margin-top: 10px;"
          >编辑</el-button>
          <el-button
            icon="el-icon-delete"
            size="small"
            type="danger"
            @click="delCard(scope.row.id)"
            style="margin-top: 10px;"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.currentPage"
          :page-sizes="[10,20,30, 50]"
          :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </template>
    <el-dialog :visible.sync="dialogFormVisible"  :title="textMap[dialogStatus]" width="60%">
      <!-- 表单折叠/展开控制器 -->
      <div v-if="formCollapsed" class="form-toggle-container">
        <el-button
          type="text"
          size="small"
          @click="formCollapsed = false"
          class="form-toggle-button"
        >
          <i class="el-icon-arrow-down"></i> 展开表单
        </el-button>
      </div>

      <!-- 表单内容 -->
      <transition name="form-fade">
        <div v-show="!formCollapsed" class="form-container">
          <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item label="类型" prop="type">
              <!-- 单选框 -->
              <el-radio-group v-model="form.type">
                <el-radio :label="0">自有</el-radio>
                <el-radio :label="1">扣子</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="名称" prop="name">
              <el-input v-model="form.name" size="small" placeholder="请输入名称" />
            </el-form-item>
            <el-form-item label="智能体标识" prop="agentSign">
              <el-input v-model="form.agentSign" size="small" placeholder="请输入智能体标识" />
            </el-form-item>
            <el-form-item label="参数列表" prop="paramList">
              <agent-param-item
                v-for="(item, index) in form.paramList"
                :key="index"
                :value="item"
                @change="handleParamChange(index, $event)"
                @delete="handleParamDelete(index)"
              ></agent-param-item>
              <el-button
                size="mini"
                type="primary"
                icon="el-icon-circle-plus"
                @click="addParam"
              >添加参数</el-button>
            </el-form-item>
            <el-form-item label="输出列表" prop="outList">
              <agent-out-item
                v-for="(item, index) in form.outList"
                :key="index"
                :value="item"
                @change="handleOutChange(index, $event)"
                @delete="handleOutDelete(index)"
              ></agent-out-item>
              <el-button
                size="mini"
                type="primary"
                icon="el-icon-circle-plus"
                @click="addOut"
              >添加输出</el-button>
            </el-form-item>
            <div class="prompt-tip">
              <span><span style="font-weight: 600;">提示词变量:</span> 变量格式 <span style="color: #2961ef; background: #e6f7ff; padding: 0 4px; border-radius: 4px;">{variable}</span>可使用变量：<span style="color: #2961ef; background: #e6f7ff; padding: 0 4px; border-radius: 4px;">{{ form.paramList.map(item => item.name).join(',') }}</span> </span>
            </div>
            <el-form-item label="系统提示词" prop="sysPrompt">
              <el-input type="textarea" rows="5" v-model="form.sysPrompt" size="small" placeholder="请输入系统提示词" />
            </el-form-item>
            <el-form-item label="用户提示词" prop="userPrompt">
              <el-input type="textarea" rows="5" v-model="form.userPrompt" size="small" placeholder="请输入用户提示词" />
            </el-form-item>
          </el-form>
        </div>
      </transition>

      <!-- 测试区域 -->
      <div class="test-prompt">
        <div class="test-prompt-content">
          <!-- 测试按钮 -->
          <div class="test-buttons">
            <el-button
              size="small"
              :loading="testLoading"
              icon="el-icon-magic-stick"
              @click="testAgent"
              type="primary"
            >测试</el-button>
          </div>

          <!-- 内容容器 -->
          <div class="test-content-wrapper">
            <!-- 错误消息 -->
            <div v-if="errorMessage" class="test-prompt-content-item-error">
              <i class="el-icon-warning"></i>
              <span>{{ errorMessage }}</span>
            </div>

            <!-- 运行过程输出 -->
            <div v-if="processOuts && processOuts.length > 0" class="test-output-section">
              <div class="test-section-header">
                <i class="el-icon-loading"></i>
                <h4 class="test-section-title">运行过程输出</h4>
              </div>
              <div class="test-prompt-content-item-result process-result">
                <div v-for="(item, index) in processOuts" :key="`process-${index}`" class="test-prompt-content-item-result-item">
                  <!-- 名称和类型 -->
                  <div class="result-item-header">
                    <div class="test-prompt-content-item-result-item-name">{{ item.name }}</div>
                    <div class="test-prompt-content-item-result-item-type">{{ item.type }}</div>
                  </div>

                  <!-- 根据类型显示内容 -->
                  <div class="result-item-content">
                    <!-- 图片 -->
                    <div v-if="item.type === 'image'" class="media-content">
                      <img :src="item.value" :alt="item.name" class="result-image" />
                    </div>

                    <!-- 视频 -->
                    <div v-else-if="item.type === 'video'" class="media-content">
                      <video :src="item.value" controls class="result-video"></video>
                    </div>

                    <!-- 文本 -->
                    <div v-else class="text-content">
                      <span>{{ item.value }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 最终结果 -->
            <div v-if="testResult && testResult.length > 0" class="test-output-section">
              <div class="test-section-header">
                <i class="el-icon-check"></i>
                <h4 class="test-section-title">最终结果</h4>
              </div>
              <div class="test-prompt-content-item-result">
                <div v-for="(item, index) in testResult" :key="`result-${index}`" class="test-prompt-content-item-result-item">
                  <!-- 名称和类型 -->
                  <div class="result-item-header">
                    <div class="test-prompt-content-item-result-item-name">{{ item.name }}</div>
                    <div class="test-prompt-content-item-result-item-type">{{ item.type }}</div>
                  </div>

                  <!-- 根据类型显示内容 -->
                  <div class="result-item-content">
                    <!-- 图片 -->
                    <div v-if="item.type === 'image'" class="media-content">
                      <img :src="item.value" :alt="item.name" class="result-image" />
                    </div>

                    <!-- 视频 -->
                    <div v-else-if="item.type === 'video'" class="media-content">
                      <video :src="item.value" controls class="result-video"></video>
                    </div>

                    <!-- 文本 -->
                    <div v-else class="text-content">
                      <span>{{ item.value }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>
<script>

import {
  getAgentList,
  addAgent,
  updateAgent,
  deleteAgent,
  runAgent,
  getAgentDetail,
  getAgentRunResult
} from '@/api/merchant/agent'
import agentParamItem from '@/components/agent/AgentParamItem.vue'
import agentOutItem from '@/components/agent/AgentOutItem.vue'

export default {
  name: 'agentBot',
  components: {
    agentParamItem,
    agentOutItem
  },
  data () {
    return {
      tableKey: 0,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      total: 0,
      testLoading: false,
      dialogFormVisible: false,
      formCollapsed: false, // 控制表单展开/折叠状态
      keywordList: [],
      testResult: [],
      processOuts: [],
      testExecuteId: '',
      pollingTimer: null,
      errorMessage: '',
      form: {
        id: '',
        type: 0, // 0 自有 1 扣子
        agentSign: '', // 智能体标识
        name: '', // 名称
        paramList: [], // 参数列表
        outList: [], // 输出列表
        sysPrompt: '', // 系统提示词
        userPrompt: '' // 用户提示词
      },
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      listLoading: false,
      rules: {
        name: [
          {
            required: true,
            message: '名称',
            trigger: 'blur'
          }
        ],
        agentSign: [
          {
            required: true,
            message: '智能体标识',
            trigger: 'blur'
          }
        ],
        paramList: [
          {
            required: true,
            message: '参数列表',
            trigger: 'blur'
          }
        ],
        outList: [
          {
            required: true,
            message: '输出列表',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getSearch()
  },
  watch: {
    $route (to, from) {
      console.log('to', to)
      if (to.path == '/merchant/agent/bot' && from.path == '/merchant/agent/bot/edit') {
        this.getSearch(this.listQuery.currentPage)
      }
    }
  },
  beforeDestroy () {
    // 组件销毁时清除定时器
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
      this.pollingTimer = null
    }
  },
  methods: {
    // 测试
    testAgent () {
      this.testLoading = true
      // 折叠表单
      this.formCollapsed = true

      // 清除之前的定时器（如果存在）
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }

      // 重置错误消息和测试结果
      this.errorMessage = ''
      this.testResult = []
      this.processOuts = []

      runAgent(this.form.id, this.form.paramList).then(res => {
        console.log('res', res)

        if (res.status == 1) {
          // 直接完成
          this.testResult = res.results
          if (res.processOuts) {
            this.processOuts = res.processOuts
          }
          this.testLoading = false
        } else if (res.status == 2) {
          // 执行出错
          this.testLoading = false
          this.errorMessage = res.message || '执行出错'
          if (res.processOuts) {
            this.processOuts = res.processOuts
          }
        } else {
          // 需要轮询查询结果
          this.testExecuteId = res.executeId
          if (res.processOuts) {
            this.processOuts = res.processOuts
          }
          this.pollExecuteResult()
        }
      }).catch((error) => {
        this.testLoading = false
        this.errorMessage = error.message || '请求出错'
      })
    },

    // 轮询执行结果
    pollExecuteResult () {
      this.pollingTimer = setInterval(() => {
        getAgentRunResult(this.form.agentSign, this.testExecuteId).then(res => {
          console.log('轮询结果', res)

          // 更新过程输出（如果有）
          if (res.processOuts) {
            this.processOuts = res.processOuts
          }

          if (res.status == 1) {
            // 执行完成，停止轮询
            this.testResult = res.results
            this.testLoading = false
            clearInterval(this.pollingTimer)
            this.pollingTimer = null
          } else if (res.status == 2) {
            // 执行出错，停止轮询
            this.testLoading = false
            this.errorMessage = res.message || '执行出错'
            clearInterval(this.pollingTimer)
            this.pollingTimer = null
          }
        }).catch((error) => {
          // 发生错误时停止轮询
          this.testLoading = false
          this.errorMessage = error.message || '轮询请求出错'
          clearInterval(this.pollingTimer)
          this.pollingTimer = null
        })
      }, 2000) // 每2秒查询一次
    },
    addParam () {
      this.form.paramList.push({
        name: '',
        type: '',
        value: []
      })
    },
    addOut () {
      this.form.outList.push({
        name: '',
        type: ''
      })
    },
    handleParamChange (index, value) {
      console.log('handleParamChange', index, value)
      this.form.paramList[index] = value
    },
    handleOutChange (index, value) {
      this.form.outList[index] = value
    },
    handleParamDelete (index) {
      this.form.paramList.splice(index, 1)
    },
    handleOutDelete (index) {
      this.form.outList.splice(index, 1)
    },
    submitForm () {
      let that = this
      if (that.dialogStatus == 'create') {
        addAgent(that.form).then(res => {
          that.$message({
            message: '添加成功',
            type: 'success',
            center: true
          })
          that.dialogFormVisible = false
          that.getSearch()
        })
      } else {
        updateAgent(that.form.id, that.form).then(res => {
          that.$message({
            message: '修改成功',
            type: 'success',
            center: true
          })
          that.dialogFormVisible = false
          that.getSearch()
        })
      }
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch(val)
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    getSearch (val) {
      let that = this
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      getAgentList(this.listQuery).then(
        res => {
          that.listLoading = true
          that.keywordList = res.records
          that.total = Number(res.total)
          that.listLoading = false
        },
        err => {
          console.log('res', err)
        }
      )
    },
    add () {
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
    },
    // 编辑
    editCard (id) {
      getAgentDetail(id).then(res => {
        this.form = res
        this.form.id = id
        this.dialogStatus = 'update'
        this.dialogFormVisible = true
      })
    },
    cancel () {
      let that = this
      that.dialogFormVisible = false
      // 清除定时器
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
      // 重置测试状态
      this.testLoading = false
      this.testResult = []
      this.processOuts = []
      this.testExecuteId = ''
      this.errorMessage = ''
      // 重置表单折叠状态
      this.formCollapsed = false
    },
    // 删除
    delCard (id) {
      let that = this
      this.$confirm('此操作将删除该智能体, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteAgent(id).then(res => {
            that.$message({
              message: '删除成功',
              type: 'success',
              center: true
            })
            that.getSearch()
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.span {
  width: 50px;
  height: 50px;
  display: block;
  margin: 0px auto;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
.prompt-tip {
  font-size: 12px;
  color: #999;
  margin: 10px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 10px;
}

.form-toggle-container {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
  padding: 10px;
  border-radius: 4px;
  background: #f5f7fa;
  border-left: 3px solid #409EFF;

  .form-toggle-button {
    color: #409EFF;
    font-weight: 500;

    &:hover {
      opacity: 0.8;
    }

    i {
      margin-right: 4px;
    }
  }
}

.form-container {
  margin-bottom: 15px;
}

/* 表单动画 */
.form-fade-enter-active, .form-fade-leave-active {
  transition: all 0.3s ease;
  max-height: 2000px;
  opacity: 1;
  overflow: hidden;
}
.form-fade-enter, .form-fade-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

.test-prompt {
  margin-top: 20px;
  .test-prompt-content {
    display: flex;
    align-items: flex-start;

    .test-buttons {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .test-content-wrapper {
      flex: 1;
      margin-left: 15px;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    }

    .test-section-header {
      display: flex;
      align-items: center;
      padding: 12px 15px;
      background: linear-gradient(90deg, rgba(64, 158, 255, 0.1) 0%, rgba(64, 158, 255, 0) 100%);
      border-left: 3px solid #409EFF;

      i {
        color: #409EFF;
        margin-right: 8px;
        font-size: 16px;
      }
    }

    .test-section-title {
      margin: 0;
      color: #303133;
      font-size: 15px;
      font-weight: 500;
    }

    .test-output-section {
      margin-bottom: 20px;
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      transition: all 0.3s ease;
      border: 1px solid #ebeef5;

      &:hover {
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
        transform: translateY(-2px);
      }
    }

    .test-prompt-content-item-result {
      padding: 15px;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
      background-color: #fbfbfb;

      &.process-result {
        background: linear-gradient(135deg, #f0f9eb 0%, #ffffff 100%);
        border-top: 1px solid #e1f3d8;
      }

      .test-prompt-content-item-error {
        width: 100%;
        color: #f56c6c;
        font-size: 14px;
        margin-bottom: 10px;
        padding: 10px 15px;
        border: 1px solid #f56c6c;
        border-radius: 4px;
        background-color: #fef0f0;
        display: flex;
        align-items: center;

        i {
          font-size: 16px;
          margin-right: 8px;
        }
      }

      .test-prompt-content-item-result-item {
        width: 100%;
        margin: 10px 0;
        border: 1px solid #ebeef5;
        padding: 0;
        border-radius: 6px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
        overflow: hidden;
        background: #fff;
        transition: all 0.3s ease;

        &:hover {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .result-item-header {
          padding: 10px 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #f5f7fa;
          border-bottom: 1px solid #ebeef5;
        }

        .test-prompt-content-item-result-item-name {
          font-size: 14px;
          font-weight: 600;
          color: #303133;
        }

        .test-prompt-content-item-result-item-type {
          font-size: 12px;
          color: #909399;
          background: rgba(144, 147, 153, 0.1);
          padding: 2px 6px;
          border-radius: 3px;
          margin-left: 8px;
        }

        .result-item-content {
          padding: 15px;
        }

        .media-content {
          display: flex;
          justify-content: center;
          align-items: center;

          .result-image {
            max-width: 100%;
            max-height: 300px;
            border-radius: 4px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          }

          .result-video {
            max-width: 100%;
            border-radius: 4px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          }
        }

        .text-content {
          font-size: 14px;
          color: #606266;
          line-height: 1.6;
          word-break: break-word;
          white-space: pre-wrap;
          background: rgba(245, 247, 250, 0.5);
          padding: 10px;
          border-radius: 4px;
          font-family: 'Courier New', monospace;
        }
      }
    }
  }
}
</style>
